import { ReactElement } from 'react';

import { HirePlanForm } from '.';
import { HirePlanFormSectionBase } from './shared/HirePlanFormSectionBase';

export function HirePlanFormSection(): ReactElement {
  return (
    <HirePlanFormSectionBase
      FormComponent={HirePlanForm}
      primaryRouteId="token"
      secondaryRouteId="token-empresa"
      maxWidthClassName="max-w-[1034px]"
      showCoverageButton
      enableProcedures
    />
  );
}
